import { Controller } from "react-hook-form";

import AssigneeFilter from "components/form_components/AssigneeFilter";
import { LeadFilterContentProps, StyledFilterContent } from "./utils";

function AssigneeFilterContent({ control }: LeadFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Assignee filter">
      <Controller
        name="assignee"
        control={control}
        render={({ field }) => <AssigneeFilter {...field} />}
      />
    </StyledFilterContent>
  );
}

export default AssigneeFilterContent;
